// RCE CSS
import 'react-chat-elements/dist/main.css';
// MessageBox component
import { MessageList, Input } from 'react-chat-elements';
import { Dimmer, Loader , Confirm , Modal , Button , Message} from 'semantic-ui-react'
import { connect } from 'react-redux';
import React, { Component, createRef } from 'react'
import { getRequestMessages, getLastRequestMessages, sendRequestMessage, enableMessaging, getSnippetsData , checkSMSDeletionEnable  , deleteIncomingSms, saveImageASSbrImage} from '../../services/Manager';
import './ChatContainerNew.less'
import moment from 'moment';
import ErrorBox from '../../components/ErrorBox/ErrorBox';
import errorImg from '../../assets/images/newui/error-cross.svg'
import ChatSnippets from '../../components/ChatSnippets/ChatSnippets'
import { formatPhone , unFormatPhone } from 'helpers/parsePhone';
import { getNameInitials } from 'helpers/parseName';
import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";
import { checkManagerAuthorization } from 'helpers/authorization';
import featuresList from '../../constants/FeaturesList';
import {SocketContext} from '../../context/socket';
import { ON_SMS_RECEIVED  , ON_SMS_STATUS_UPDATED} from 'constants/socketIOListener';

let ApiCallInterval;

const initialStates = {
    loading: false,
    chatData: [],
    messageText: "",
    inputFieldKey: 1,
    orignalChatData: [],
    lastQueryDate: undefined,
    disableSendBtn: false,
    showError: false,
    errorMessage: "Unable to send message. Please try again later, this number may be invalid.",
    isSnippetsOpen: false,
    textAreaHeight: undefined,
    isSnippetsLoaded: false,
    chatSnippetsData: [],
    chatType: 'buyer',
    enableMessaging: false,
    enableMessagingResponse: false,
    selectedChatImagesURI : "",
    smsDeletionEnabled : false,
    openSmsDeleteConfirmModal:false,
    deletionSelectedSms:{},
    sendSMSEnabled:false,
    saveAsImageModalOpen:false,
    saveAsImageEnabled: false,
    selectedMediaObject: undefined,
    imageSaveAsError:"",
    saveAsImageModalSaveButtonDisabled:false
}

class ChatContainerNew extends Component {
    static contextType = SocketContext

    constructor(props) {
        super(props);
        this.state = { ...initialStates };
        this.inputField = createRef();
    }

    componentDidMount = async () => {
        const socket = this.context
        this.onDataLoad(socket);
        // let delRes = await checkSMSDeletionEnable();
        // if (delRes.resStatus == 200) {
        //     this.setState({ smsDeletionEnabled: delRes.data.enabled })
        // }
        this.setState({ smsDeletionEnabled: checkManagerAuthorization(featuresList.DELETE_SMS, this.props.currentUser),
            sendSMSEnabled : checkManagerAuthorization(featuresList.SEND_SMS, this.props.currentUser),
            saveAsImageEnabled: checkManagerAuthorization(featuresList.SAVE_SMS_IMAGE_TO_SBR, this.props.currentUser)
        })     
    }

    componentDidUpdate(prevProps) {
        const socket = this.context
        if (prevProps.singleBuyerRequestID != this.props.singleBuyerRequestID) {
            this.onDataLoad(socket);

        }
        if (prevProps.service.serviceID != this.props.service.serviceID) {
            // Load snippets if service is changed.
            this.setState({ isSnippetsLoaded: false })
        }
    }

    onDataLoad = async (socket) => {

        if (ApiCallInterval) {
            clearInterval(ApiCallInterval)
        }
        this.getMessages();
        const singleBuyerRequestID = this.props.singleBuyerRequestID;
        const enableMessagingRes = await enableMessaging(singleBuyerRequestID);
        if (enableMessagingRes.resStatus == 200) {
            this.setState({ enableMessagingResponse: enableMessagingRes }, () => {
                this.handleEnableMessaging(enableMessagingRes)
            });
        }
        // let key = ON_SMS_RECEIVED+"+1"+this.props.buyer.buyerCellPhone;
        let key = ON_SMS_RECEIVED.replace("<PHONE_NO>" , "+1"+this.props.buyer.buyerCellPhone)
        socket.on(key, (messages) => {
            
            let isShowHiddenSms = checkManagerAuthorization(featuresList.SHOW_HIDDEN_OUTGOING_SMS, this.props.currentUser);
            let skipSMS = false;

            if (messages.length > 0) {

                    let newOrignalDataBuyer = [...this.state.orignalChatData.buyerMessages];
                    let buyerNewMsg = [];
                    messages.forEach((message) => {

                        if (message.isHidden && message.isHidden == true) {
                            skipSMS = true;
                            if (isShowHiddenSms) {
                                skipSMS = false;
                            }
                        }

                        if (!skipSMS) {
                            if (message.fromPhone == "+1" + this.props.buyer.buyerCellPhone ||
                                message.toPhone == "+1" + this.props.buyer.buyerCellPhone) {
                                // if (message.status === "received") {
                                newOrignalDataBuyer.push(message);
                                buyerNewMsg.push(message);
                                // }
                            }
                        }
                    });

                    this.setState({ orignalChatData: { ...this.state.orignalChatData , buyerMessages: [...newOrignalDataBuyer], 
                        // sellerMessages: [...newOrignalDataSeller] 
                    }, lastQueryDate: moment() }, () => {
                        // check is new buyer or seller data is returned from api then update it in display chat state.
                        if (this.state.chatType == "buyer" && buyerNewMsg.length) {

                            this.setState({
                                chatData: [
                                    ...this.getMappedMessages(newOrignalDataBuyer)
                                ]
                            })
                            setTimeout(() => {
                                this.scrollDivToBottom();
                            }, 10);

                        } 
                        // else if (this.state.chatType == "seller" && sellerNewMsg.length) {
                        //     this.setState({
                        //         chatData: [
                        //             ...this.getMappedMessages(newOrignalDataSeller)
                        //         ]
                        //     })

                        //     setTimeout(() => {
                        //         this.scrollDivToBottom();
                        //     }, 10);
                        // }
                    });
                // }
            }
        });

        key = ON_SMS_RECEIVED.replace("<PHONE_NO>", "+1" + unFormatPhone(this.props.sbr.sellerPhone))
        socket.on(key, (messages) => {

            let isShowHiddenSms = checkManagerAuthorization(featuresList.SHOW_HIDDEN_OUTGOING_SMS, this.props.currentUser);
            let skipSMS = false;

            if (messages.length > 0) {
                // if (this.state.chatData.length > 0) {

                // let newOrignalDataBuyer = [...this.state.orignalChatData.buyerMessages];
                let newOrignalDataSeller = [...this.state.orignalChatData.sellerMessages];
                // let buyerNewMsg = [];
                let sellerNewMsg = [];
                messages.forEach((message) => {
                    if (message.isHidden && message.isHidden == true) {
                        skipSMS = true;
                        if (isShowHiddenSms) {
                            skipSMS = false;
                        }
                    }

                    if (!skipSMS) {
                        if (message.fromPhone == "+1" + unFormatPhone(this.props.sbr.sellerPhone) ||
                            message.toPhone == "+1" + unFormatPhone(this.props.sbr.sellerPhone)) {
                            // if (message.status === "received") {
                            newOrignalDataSeller.push(message);
                            sellerNewMsg.push(message);
                            // } 
                        }
                    }
                });

                this.setState({
                    orignalChatData: {
                        ...this.state.orignalChatData,
                        // buyerMessages: [...newOrignalDataBuyer], 
                        sellerMessages: [...newOrignalDataSeller]
                    }, lastQueryDate: moment()
                }, () => {
                    // check is new buyer or seller data is returned from api then update it in display chat state.
                    // if (this.state.chatType == "buyer" && buyerNewMsg.length) {

                    //     this.setState({
                    //         chatData: [
                    //             ...this.getMappedMessages(newOrignalDataBuyer)
                    //         ]
                    //     })
                    //     setTimeout(() => {
                    //         this.scrollDivToBottom();
                    //     }, 10);

                    // } else 
                    if (this.state.chatType == "seller" && sellerNewMsg.length) {
                        this.setState({
                            chatData: [
                                ...this.getMappedMessages(newOrignalDataSeller)
                            ]
                        })

                        setTimeout(() => {
                            this.scrollDivToBottom();
                        }, 10);
                    }
                });
                // }
            }
        });

        key = ON_SMS_STATUS_UPDATED.replace("<PHONE_NO>" , "+1"+this.props.buyer.buyerCellPhone)
        socket.on(key, (response) => {
            let orignalDataBuyer = [...this.state.orignalChatData.buyerMessages];
            let orignalDataSeller = [...this.state.orignalChatData.sellerMessages];
            let buyerSMSIndex = orignalDataBuyer.findIndex((item) => {
                return item.messageSID == response.messageSID
            });
            if (buyerSMSIndex != -1) {
                orignalDataBuyer[buyerSMSIndex]['status'] = response.messageStatus
            }

            let sellerSMSIndex = orignalDataSeller.findIndex((item) => {
                return item.messageSID == response.messageSID
            });
            if (sellerSMSIndex != -1) {
                orignalDataSeller[sellerSMSIndex]['status'] = response.messageStatus
            }

            this.setState({ orignalChatData: { buyerMessages: [...orignalDataBuyer], sellerMessages: [...orignalDataSeller] }}, () => {
                // check is new buyer or seller data is returned from api then update it in display chat state.
                if (this.state.chatType == "buyer" && buyerSMSIndex != -1) {

                    this.setState({
                        chatData: [
                            ...this.getMappedMessages(orignalDataBuyer)
                        ]
                    })
                    setTimeout(() => {
                        this.scrollDivToBottom();
                    }, 10);

                } else if (this.state.chatType == "seller" && sellerSMSIndex != -1) {
                    this.setState({
                        chatData: [
                            ...this.getMappedMessages(orignalDataSeller)
                        ]
                    })

                    setTimeout(() => {
                        this.scrollDivToBottom();
                    }, 10);
                }
            });
        });

        key = ON_SMS_STATUS_UPDATED.replace("<PHONE_NO>" , "+1"+unFormatPhone(this.props.sbr.sellerPhone))
        socket.on(key, (response) => {
            let orignalDataBuyer = [...this.state.orignalChatData.buyerMessages];
            let orignalDataSeller = [...this.state.orignalChatData.sellerMessages];
            let buyerSMSIndex = orignalDataBuyer.findIndex((item) => {
                return item.messageSID == response.messageSID
            });
            if (buyerSMSIndex != -1) {
                orignalDataBuyer[buyerSMSIndex]['status'] = response.messageStatus
            }

            let sellerSMSIndex = orignalDataSeller.findIndex((item) => {
                return item.messageSID == response.messageSID
            });
            if (sellerSMSIndex != -1) {
                orignalDataSeller[sellerSMSIndex]['status'] = response.messageStatus
            }

            this.setState({ orignalChatData: { buyerMessages: [...orignalDataBuyer], sellerMessages: [...orignalDataSeller] }}, () => {
                // check is new buyer or seller data is returned from api then update it in display chat state.
                if (this.state.chatType == "buyer" && buyerSMSIndex != -1) {

                    this.setState({
                        chatData: [
                            ...this.getMappedMessages(orignalDataBuyer)
                        ]
                    })
                    setTimeout(() => {
                        this.scrollDivToBottom();
                    }, 10);

                } else if (this.state.chatType == "seller" && sellerSMSIndex != -1) {
                    this.setState({
                        chatData: [
                            ...this.getMappedMessages(orignalDataSeller)
                        ]
                    })

                    setTimeout(() => {
                        this.scrollDivToBottom();
                    }, 10);
                }
            });
        });

        // ApiCallInterval = setInterval(async () => {
        //     if (this.state.chatData.length > 0) {
        //         let lastQueryDate = this.state.lastQueryDate;
        //         const messages = await getLastRequestMessages(singleBuyerRequestID, lastQueryDate);

        //         let newOrignalDataBuyer = [...this.state.orignalChatData.buyerMessages];
        //         let newOrignalDataSeller = [...this.state.orignalChatData.sellerMessages];

        //         messages.data.buyerMessages.forEach((message) => {
        //             if (message.status === "received") {
        //                 newOrignalDataBuyer.push(message);

        //             } else if (message.status == "sent" || message.status == "failed" || message.status == "undelivered") {
        //                 let msgIndex = newOrignalDataBuyer.findIndex((item) => item.messageSID == message.messageSID);
        //                 if (msgIndex != -1) {
        //                     let outgoingMsgObject = newOrignalDataBuyer[msgIndex];
        //                     outgoingMsgObject.status = message.status;
        //                     outgoingMsgObject.fromUserFirstName = message.fromUserFirstName;
        //                     outgoingMsgObject.fromUserLastName = message.fromUserLastName;
        //                     newOrignalDataBuyer[msgIndex] = outgoingMsgObject;
        //                 } else {
        //                     newOrignalDataBuyer.push(message);
        //                 }
        //             }
        //         });
        //         messages.data.sellerMessages.forEach((message) => {
        //             if (message.status === "received") {
        //                 newOrignalDataSeller.push(message);
        //             } else if (message.status == "sent" || message.status == "failed" || message.status == "undelivered") {
        //                 let msgIndex = newOrignalDataSeller.findIndex((item) => item.messageSID == message.messageSID);
        //                 if (msgIndex != -1) {
        //                     let outgoingMsgObject = newOrignalDataSeller[msgIndex];
        //                     outgoingMsgObject.status = message.status;
        //                     outgoingMsgObject.fromUserFirstName = message.fromUserFirstName;
        //                     outgoingMsgObject.fromUserLastName = message.fromUserLastName;
        //                     newOrignalDataSeller[msgIndex] = outgoingMsgObject;
        //                 } else {
        //                     newOrignalDataSeller.push(message);
        //                 }
        //             }
        //         });

        //         this.setState({ orignalChatData: { buyerMessages: [...newOrignalDataBuyer], sellerMessages: [...newOrignalDataSeller] }, lastQueryDate: moment() }, () => {
        //             // check is new buyer or seller data is returned from api then update it in display chat state.
        //             if (this.state.chatType == "buyer" && messages.data.buyerMessages.length) {

        //                 this.setState({ chatData: [
        //                     // ...newOrignalDataBuyer.map((msg) => {  return this.getMessageObject(msg) })
        //                     ...this.getMappedMessages(newOrignalDataBuyer) 
        //                 ]})
        //                 setTimeout(() => {
        //                     this.scrollDivToBottom();
        //                 }, 10);

        //             } else if (this.state.chatType == "seller" && messages.data.sellerMessages.length) {
        //                 this.setState({ chatData: [
        //                     // ...newOrignalDataSeller.map((msg) => { return this.getMessageObject(msg) })
        //                     ...this.getMappedMessages(newOrignalDataSeller) 
        //                 ] })

        //                 setTimeout(() => {
        //                     this.scrollDivToBottom();
        //                 }, 10);
        //             }
        //         });
        //     }
        // }, 10000);
    }


    getMappedMessages = (dataToShow) => {
        let data = [];
        dataToShow.forEach((message) => {
            if(!message.media)
            {
                data.push(this.getMessageObject(message,true))
            }

            if(message.media && message.media.length == 1)
            {
                data.push(this.getMessageObject(message,true))
            }else if (message.media && message.media.length > 1)
            {
                message.media.forEach((media) => {
                    data.push(this.getPhotoMessageObject(media,message))

                })
                data.push(this.getMessageObject(message,false))
            }            
        });
        return data;
    }

    handleEnableMessaging = (enableMessagingRes = this.state.enableMessagingResponse) => {
        if (this.state.chatType == "buyer") {
            this.setState({ enableMessaging: enableMessagingRes.data.buyer.enabled });
        } else if (this.state.chatType == "seller") {
            this.setState({ enableMessaging: enableMessagingRes.data.seller.enabled });
        }
    }

    getMessages = async (fetchFromAPI = true) => {
        if (fetchFromAPI) {
            this.setState({ loading: true });
        }

        const singleBuyerRequestID = this.props.singleBuyerRequestID;
        let messages;
        if (fetchFromAPI) {
            messages = await getRequestMessages(singleBuyerRequestID);
        }
        else {
            messages = { data: this.state.orignalChatData, resStatus: 200 }
        }
        let messagesDataSouce = [];
        if (messages.resStatus === 200) {
            let dataToShow = []
            if (this.state.chatType == "buyer") {
                dataToShow = [...messages.data.buyerMessages];
            } else if (this.state.chatType == "seller") {
                dataToShow = [...messages.data.sellerMessages];
            }
                            // dataToShow.forEach((message) => {

                            //     if(!message.media)
                            //     {
                            //         messagesDataSouce.push(this.getMessageObject(message,true))
                            //     }

                            //     if(message.media && message.media.length == 1)
                            //     {
                            //         messagesDataSouce.push(this.getMessageObject(message,true))
                            //     }else if (message.media && message.media.length > 1)
                            //     {
                            //         message.media.forEach((media) => {
                            //             messagesDataSouce.push(this.getPhotoMessageObject(media,message))

                            //         })
                            //         messagesDataSouce.push(this.getMessageObject(message,false))
                            //     }
                            // });

            messagesDataSouce = this.getMappedMessages(dataToShow);

        }
        setTimeout(() => {
            this.setState({
                chatData: messagesDataSouce, orignalChatData: messages.data,
                lastQueryDate: moment(),
                loading: false,
            });
            setTimeout(() => {
                this.scrollDivToBottom();
            }, 10);

        }, fetchFromAPI ? 500 : 0);
    }

    getPhotoMessageObject = (mediaObject ,Message ) => {

        let messageObject = {
            // text: "",
            position: Message.status === "received" ? "left" : "right",
            type: "photo",
            date: new Date(Message.originalTextDate),
            // dateString: this.getTimeStamp(Message.originalTextDate),
            dateString: this.getTimeStamp(Message.originalTextDate),
            smsID: Message.smsID,
            messageSID: Message.messageSID,

            // removeButton:  Message.status == "received" && this.state.smsDeletionEnabled ?  true : false,
            
            // title: ((Message.status === 'failed' || Message.status === 'undelivered') ? this.getErrorTitle() : ""),
            // titleColor:(Message.status === 'failed' || Message.status === 'undelivered') ? "red" : "",
            // className: (Message.status === 'failed' || Message.status === 'undelivered') ? "error-box" : "",

            renderAddCmp: () => {
                return (
                    <>
                        {
                            this.state.saveAsImageEnabled ?
                                <svg onClick={(e) => {
                                    this.setState({ saveAsImageModalOpen: true, selectedMediaObject: mediaObject, imageSaveAsError: "" })
                                    e.stopPropagation();
                                    e.nativeEvent.stopImmediatePropagation();
                                }}
                                    className={"upload icon"} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32">
                                    <g id="Upload_Icon" data-name="Upload Icon" transform="translate(-347 -607)">
                                        <g id="Rectangle" transform="translate(347 607)" fill="#8a8a91" stroke="#fff" stroke-miterlimit="10" stroke-width="0.632">
                                            <rect width="32" height="32" rx="6.316" stroke="none" />
                                            <rect x="0.316" y="0.316" width="35.368" height="35.368" rx="6" fill="none" />
                                        </g>
                                        <g id="Group_16385" data-name="Group 16385" transform="translate(351.668 613.644)">
                                            <g id="Group_16386" data-name="Group 16386" transform="translate(0 0)">
                                                <path id="Path_29511" data-name="Path 29511" d="M15.519,15.463c-.653,0-.306,0-.959,0a.721.721,0,0,1-.737-.534.709.709,0,0,1,.665-.9c.63-.009.26,0,.891,0,.608,0,1.215,0,1.823,0a3.192,3.192,0,0,0,3.059-2.081A3.124,3.124,0,0,0,19.547,8.5a3.044,3.044,0,0,0-2.12-.953.743.743,0,0,1-.7-.4.924.924,0,0,1-.083-.358,6.142,6.142,0,0,0-.2-1.458,5.243,5.243,0,0,0-2.919-3.421,5.033,5.033,0,0,0-2.573-.458A5.189,5.189,0,0,0,7.363,3.247,5.182,5.182,0,0,0,6.04,6.5c-.005.1,0,.2,0,.3a.716.716,0,0,1-.6.724.687.687,0,0,1-.118.008c-.3,0-.606-.005-.906.017a3.119,3.119,0,0,0-1.946.857,3.239,3.239,0,0,0,.267,4.966,3.116,3.116,0,0,0,1.765.639c.3.013.6.012.907.013.989,0,.978.006,1.968,0a.731.731,0,0,1,.747.707.72.72,0,0,1-.63.724.939.939,0,0,1-.11.008c-1.272,0-1.544.009-2.815-.006a4.457,4.457,0,0,1-2.713-.946,4.511,4.511,0,0,1-1.8-3.025A4.546,4.546,0,0,1,1.592,7.267,4.49,4.49,0,0,1,3.966,6.152c.2-.031.4-.039.6-.054.044,0,.071-.008.076-.064a6.174,6.174,0,0,1,.606-2.168A6.69,6.69,0,0,1,9.3.32,6.51,6.51,0,0,1,12.04.038a6.752,6.752,0,0,1,5.926,5.5c.032.181.055.363.077.546a.105.105,0,0,0,.1.108,4.645,4.645,0,0,1,3.766,4.258,4.509,4.509,0,0,1-.761,2.905,4.567,4.567,0,0,1-3.083,2.029,5.827,5.827,0,0,1-.91.077c-.545.012-1.091,0-1.636,0" transform="translate(0 0)" fill="#fff" stroke="#fff" stroke-width="0.4" />
                                                <path id="Path_29512" data-name="Path 29512" d="M242.779,263.976a.5.5,0,0,1-.051.076c-.253.263-.5.528-.762.785a.721.721,0,0,1-1.219-.373.7.7,0,0,1,.207-.651q.58-.595,1.158-1.191c.3-.3.588-.611.887-.911a.715.715,0,0,1,.968-.082,2.661,2.661,0,0,1,.244.235q.949.975,1.9,1.952a.72.72,0,0,1-.2,1.171.712.712,0,0,1-.812-.154c-.253-.255-.5-.515-.75-.773a.256.256,0,0,0-.091-.068v.093c0,2.153,0,5.307,0,7.46a.765.765,0,0,1-.166.512.718.718,0,0,1-1.272-.422c0-.045,0-.09,0-.136,0-2.134,0-5.267,0-7.4v-.106l-.031-.019" transform="translate(-232.569 -253.744)" fill="#fff" stroke="#fff" stroke-width="0.4" />
                                            </g>
                                        </g>
                                    </g>
                                </svg>
                                : ""
                        }
                    </>
                )
            },

            data: {
                // width : '100%',
                // height: '100%',
                uri: mediaObject.URL,
                status: {
                    // download:false,
                    click: true,
                    // loading: 0,
                }
            }
        }

        return messageObject;
    }

    saveImageAsSBRPhoto = (e, mediaObject) => {
        this.setState({ saveAsImageModalSaveButtonDisabled: true })

        saveImageASSbrImage(mediaObject.imageID, this.props.buyer.buyerID, this.props.singleBuyerRequestID).then((res) => {
            if (res.resStatus == 200) {
                this.setState({ selectedMediaObject: undefined, saveAsImageModalOpen: false, imageSaveAsError: "" })
            } else {
                this.setState({ imageSaveAsError: res.message })
            }
            this.setState({ saveAsImageModalSaveButtonDisabled: false })
        });

        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    getMessageObject = (Message , checkMedia=false) => {
        let messageObject = {
            text: <>
                {
                    Message.body.length ?
                        <p className={"message-paragraph"}> {Message.body}</p> : ""
                }

                {
                    Message.status != "received" ?
                        <div className={"message-sender"}>
                            {Message.fromUserFirstName ? Message.fromUserFirstName + ", " + getNameInitials(Message.fromUserLastName, 2) : "System Generated"}
                        </div>
                        : ""
                }
            </>,
            position: Message.status === "received" ? "left" : "right",
            type: 'text',
            date: new Date(Message.originalTextDate),
            dateString: this.getTimeStamp(Message.originalTextDate),
            messageSID: Message.messageSID,
            smsID: Message.smsID,
            title: ((Message.status === 'failed' || Message.status === 'undelivered') ? this.getErrorTitle() : ""),
            titleColor:(Message.status === 'failed' || Message.status === 'undelivered') ? "red" : "",
            className: (Message.status === 'failed' || Message.status === 'undelivered') ? "error-box" : "",
            // renderAddCmp: () => this.abc(),
            removeButton:  Message.status == "received" && this.state.smsDeletionEnabled ?  true : false,
            // onRemoveMessageClick: (e) => this.handleDeleteSmsClick(),
            // onClick : function (e) {
            //     this.downloadChatImage(e)
            // }
        }

        //         media: {imageID: 62,…}
        // URL: "https://5365-103-159-75-243.ngrok.io/api/uploads/get/me-9-fea-2461-ddeeeab-99-ce-3-_li7na4bl0b3zlsv_.jpeg"
        // imageID: 62
        // updatedOn: "2022-03-03T14:54:34.015Z"



        // onClick={this.props.onOpen}
        // onLoad={this.props.onLoad}
        // onError={this.props.onPhotoError}/>

        if ( checkMedia && Message.media && Message.media.length) {
            messageObject = {
                ...messageObject,
                type: "photo",

                renderAddCmp: () => {
                    return (
                        <>
                            {
                                this.state.saveAsImageEnabled ?
                                    <svg onClick={(e) => {
                                        this.setState({ saveAsImageModalOpen: true, selectedMediaObject: Message.media[0], imageSaveAsError: "" })
                                        e.stopPropagation();
                                        e.nativeEvent.stopImmediatePropagation();
                                    }}
                                        className={"upload icon"} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32">
                                        <g id="Upload_Icon" data-name="Upload Icon" transform="translate(-347 -607)">
                                            <g id="Rectangle" transform="translate(347 607)" fill="#8a8a91" stroke="#fff" stroke-miterlimit="10" stroke-width="0.632">
                                                <rect width="32" height="32" rx="6.316" stroke="none" />
                                                <rect x="0.316" y="0.316" width="35.368" height="35.368" rx="6" fill="none" />
                                            </g>
                                            <g id="Group_16385" data-name="Group 16385" transform="translate(351.668 613.644)">
                                                <g id="Group_16386" data-name="Group 16386" transform="translate(0 0)">
                                                    <path id="Path_29511" data-name="Path 29511" d="M15.519,15.463c-.653,0-.306,0-.959,0a.721.721,0,0,1-.737-.534.709.709,0,0,1,.665-.9c.63-.009.26,0,.891,0,.608,0,1.215,0,1.823,0a3.192,3.192,0,0,0,3.059-2.081A3.124,3.124,0,0,0,19.547,8.5a3.044,3.044,0,0,0-2.12-.953.743.743,0,0,1-.7-.4.924.924,0,0,1-.083-.358,6.142,6.142,0,0,0-.2-1.458,5.243,5.243,0,0,0-2.919-3.421,5.033,5.033,0,0,0-2.573-.458A5.189,5.189,0,0,0,7.363,3.247,5.182,5.182,0,0,0,6.04,6.5c-.005.1,0,.2,0,.3a.716.716,0,0,1-.6.724.687.687,0,0,1-.118.008c-.3,0-.606-.005-.906.017a3.119,3.119,0,0,0-1.946.857,3.239,3.239,0,0,0,.267,4.966,3.116,3.116,0,0,0,1.765.639c.3.013.6.012.907.013.989,0,.978.006,1.968,0a.731.731,0,0,1,.747.707.72.72,0,0,1-.63.724.939.939,0,0,1-.11.008c-1.272,0-1.544.009-2.815-.006a4.457,4.457,0,0,1-2.713-.946,4.511,4.511,0,0,1-1.8-3.025A4.546,4.546,0,0,1,1.592,7.267,4.49,4.49,0,0,1,3.966,6.152c.2-.031.4-.039.6-.054.044,0,.071-.008.076-.064a6.174,6.174,0,0,1,.606-2.168A6.69,6.69,0,0,1,9.3.32,6.51,6.51,0,0,1,12.04.038a6.752,6.752,0,0,1,5.926,5.5c.032.181.055.363.077.546a.105.105,0,0,0,.1.108,4.645,4.645,0,0,1,3.766,4.258,4.509,4.509,0,0,1-.761,2.905,4.567,4.567,0,0,1-3.083,2.029,5.827,5.827,0,0,1-.91.077c-.545.012-1.091,0-1.636,0" transform="translate(0 0)" fill="#fff" stroke="#fff" stroke-width="0.4" />
                                                    <path id="Path_29512" data-name="Path 29512" d="M242.779,263.976a.5.5,0,0,1-.051.076c-.253.263-.5.528-.762.785a.721.721,0,0,1-1.219-.373.7.7,0,0,1,.207-.651q.58-.595,1.158-1.191c.3-.3.588-.611.887-.911a.715.715,0,0,1,.968-.082,2.661,2.661,0,0,1,.244.235q.949.975,1.9,1.952a.72.72,0,0,1-.2,1.171.712.712,0,0,1-.812-.154c-.253-.255-.5-.515-.75-.773a.256.256,0,0,0-.091-.068v.093c0,2.153,0,5.307,0,7.46a.765.765,0,0,1-.166.512.718.718,0,0,1-1.272-.422c0-.045,0-.09,0-.136,0-2.134,0-5.267,0-7.4v-.106l-.031-.019" transform="translate(-232.569 -253.744)" fill="#fff" stroke="#fff" stroke-width="0.4" />
                                                </g>
                                            </g>
                                        </g>
                                    </svg>
                                    : ""
                            }
                        </>
                    )
                },

                data: {
                    // width : '100%',
                    // height: '100%',
                    uri: Message.media[0].URL,
                    status: {
                        // download:false,
                        click: true,
                        // loading: 0,
                    }
                },
                onClick: (e) => {
                    console.log("click ", e);
                }
            }
        }
                // {
                //     type: 'photo',
                //     data: {
                //         width : 100,
                //         height: 100,
                //         uri: ['https://5365-103-159-75-243.ngrok.io/api/uploads/get/m-efc-4-f-69764-b-52-bd-0-cdfc_li7na4bl0b3zlra_.jpeg'],
                //         status: {
                           
                //         }
                //     },          
                // }

        return messageObject;
    }

    getTimeStamp = (date) => {
        try {
            return moment(new Date(date)).format('MM/DD/YY HH:mm:ss');
        } catch (ex) {
            return "Invalid Date";
        }
    }

    componentWillUnmount = () => {
        clearInterval(ApiCallInterval);
    }

    getErrorTitle = () => {
        return <>
            <div style={{ display: "flex" }}>
                <img src={errorImg}></img>
                <p className={"error-status-text"}> {"Delivery Failed"}
                </p>
            </div>
        </>
    }

    onCancel = () => {
        this.props.onClose();
    }

    scrollDivToBottom = () => {
        if (window.innerWidth > 768) {
            var elements = document.getElementsByClassName("rce-container-mbox");
            if (elements.length) {
                let element = elements[elements.length - 1];
                element.scrollIntoView({
                    behavior: 'smooth',
                    inline: 'center'
                });
            }
        }
    }

    scrollOnError = () => {
        let element = document.getElementById("error-box-container-id");
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                inline: 'center'
            });
        }
    }

    sendMessage = async (e) => {
        if (this.state.messageText.length > 0 && !this.state.disableSendBtn) {
            this.setState({ disableSendBtn: true, showError: false })
            const singleBuyerRequestID = this.props.singleBuyerRequestID;
            let messagesResponse;
            messagesResponse = await sendRequestMessage(singleBuyerRequestID, this.state.messageText, this.state.chatType)

            if (messagesResponse.resStatus == 200) {
                this.setState({ messageText: "", inputFieldKey: this.state.inputFieldKey + 1 });
            } else {
                this.setState({ showError: true, errorMessage: messagesResponse.message })
                this.scrollOnError();
            }
            // if (messagesResponse.resStatus == 200) {
            //     let newMesseg = {
            //         position: 'right',
            //         type: 'text',
            //         text:
            //         <>
            //             <p className={"message-paragraph"}> {messagesResponse.data.message.body}</p>                    
            //                     <div className={"message-sender"}>
            //                         {this.props.currentUser.firstName + ", " + getNameInitials(this.props.currentUser.lastName, 2)}
            //                     </div>       
            //         </>,
            //         date: new Date(messagesResponse.data.message.originalTextDate),
            //         dateString: this.getTimeStamp(messagesResponse.data.message.originalTextDate),
            //         messageSID: messagesResponse.data.message.messageSID,
            //     }
            //     let updatedData = this.state.chatData;
            //     updatedData.push(newMesseg);
            //     let orignalData = this.state.orignalChatData;

            //     if (this.state.chatType == "buyer") {
            //         orignalData.buyerMessages.push({...messagesResponse.data.message ,
            //              fromUserFirstName : this.props.currentUser.firstName , fromUserLastName : getNameInitials(this.props.currentUser.lastName, 2) });
            //     } else if (this.state.chatType == "seller") {
            //         orignalData.sellerMessages.push({...messagesResponse.data.message , 
            //             fromUserFirstName : this.props.currentUser.firstName , fromUserLastName : getNameInitials(this.props.currentUser.lastName, 2) });
            //     }
            //     this.setState({ chatData: updatedData, messageText: "", inputFieldKey: this.state.inputFieldKey + 1, orignalChatData: orignalData });
            //     setTimeout(() => {
            //         this.scrollDivToBottom();
            //     }, 1);
            // } else {
            //     this.setState({ showError: true  , errorMessage : messagesResponse.message})
            //     this.scrollOnError();
            // }
            this.setState({ disableSendBtn: false })
        }
    }

    valueChange = (e) => {
        this.setState({ messageText: e.target.value, showError: e.target.value.length == 0 ? false : this.state.showError })
    }

    expandChat = () => {
        this.props.expandComponent();
    }

    loadSnippetsData = async () => {
        let snippertData = await getSnippetsData(this.props.singleBuyerRequestID);
        if (snippertData.resStatus == 200) {
            this.setState({ chatSnippetsData: snippertData.data, isSnippetsLoaded: true })
        } else {
            this.setState({ isSnippetsLoaded: false })
        }
    }

    toggleSnippets = () => {
        this.props.toggleSnippets(!this.props.isSnippetsOpen);
        // On open, get snippets
        setTimeout(() => {
            if (this.state.isSnippetsLoaded == false) {
                this.loadSnippetsData();
            }
        }, 1000);
    }

    onSnippetSelect = (snippetText) => {
        this.setState({ messageText: snippetText, inputFieldKey: this.state.inputFieldKey + 1 }, () => {

            this.inputField.current.style.height = this.inputField.current.scrollHeight + "px";
            //this.inputField.current.input.style.width = '400px'
        })
        this.props.toggleSnippets(false);
        // Calculate chat textarea height in case snippet is selected.
        // let messageLength = snippetText.length;
        // let no_of_lines = Math.ceil(messageLength / 60);
        // let height = (no_of_lines * 25) + "px";
        // this.setState({ textAreaHeight: height })

        //console.log(this.inputField.current.input);
        //this.inputField.current.props.onChange();     
        //"430px";
    }

    chatTypeHandler = (chatType) => {
        this.setState({ chatType: chatType, showError: false }, () => {
            this.getMessages(false);
            this.handleEnableMessaging();
        })
    }

    downloadChatImage = (e) => {
        if( e.data && e.data.uri && e.data.uri.length)
        {
            this.setState({ selectedChatImagesURI:  e.data.uri })
        }   
    }


    handleOnLoad = (e) => {
        console.log('load' , e)
    }

    handleOnPhotoError = (e) => {
        console.log('error' , e)
    }

    handleDeleteSmsClick = (messageObject, e) => {
        this.setState({ deletionSelectedSms: messageObject }, () => {
            this.onSmsDeleteConfirmModalOpen();       
        })
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    onSmsDeleteConfirmModalClose = () => {
        this.setState({openSmsDeleteConfirmModal : false})
    }

    onSmsDeleteConfirmModalOpen = () => {
        this.setState({openSmsDeleteConfirmModal : true})
    }
    
    onSmsDeleteConfirm = async () => {
        let deletionSelectedSms =  this.state.deletionSelectedSms;
        let chatData = [...this.state.chatData];
        let orignalChatData = this.state.orignalChatData;
        if(deletionSelectedSms)
        {
            // delete from chat data , multiple record can be found due to multi image support.
            let delRes = await deleteIncomingSms(deletionSelectedSms.smsID);
            if(delRes.resStatus == 200)
            {
                chatData = [...chatData.filter((item) => item.messageSID != deletionSelectedSms.messageSID)];   
                orignalChatData.buyerMessages = [...orignalChatData.buyerMessages.filter((item) => item.messageSID != deletionSelectedSms.messageSID)]; 
                orignalChatData.sellerMessages = [...orignalChatData.sellerMessages.filter((item) => item.messageSID != deletionSelectedSms.messageSID)]; 
                this.setState({chatData: [...chatData] , orignalChatData : orignalChatData})
            }
            this.setState({openSmsDeleteConfirmModal : false})
        }   
    }

    render() {
        return (
            <>
                <div className={`request-SMS-new form-container ${this.props.isExpand ? "expand" : ""} ${this.state.loading ? "loading" : ""}`}>
                    {
                        this.state.loading ?
                            <Dimmer active={true}>
                                <Loader active={true} size='massive'  > </Loader>
                            </Dimmer>
                            :
                            <>
                                <div className={"header-container"}>
                                    {/* <div className={"heading"}>

                                    </div> */}

                                    <div className={"chat-type-container"}>
                                        <div onClick={this.state.chatType == "buyer" ? () => { } : () => { this.chatTypeHandler("buyer") }}
                                            className={`chat-type buyer-chat-header-container ${this.state.chatType == "buyer" ? "selected" : ""}`}>
                                            <div className={"tab-heading"}>
                                                {
                                                    this.state.chatType == "buyer" ? "Buyer" : getNameInitials(this.props.buyer.buyerName)
                                                }
                                            </div>
                                            {
                                                this.state.chatType == "buyer" ?
                                                    <div className={"tab-contant"}>
                                                        <div className={"name"}>
                                                            {this.props.buyer.buyerName ?  this.props.buyer.buyerName[0].toUpperCase() + this.props.buyer.buyerName.substring(1) : ""}
                                                        </div>
                                                        <div className={"number"}>
                                                             { this.props.buyer ? formatPhone(this.props.buyer.buyerCellPhone) : ""}
                                                        </div>
                                                    </div>
                                                    : ""}
                                        </div>

                                        {this.props.sbr.isAccepted || this.props.sbr.servicedAt ?
                                            <div onClick={this.state.chatType == "seller" ? () => { } : () => { this.chatTypeHandler("seller") }}
                                                className={`chat-type seller-chat-header-container ${this.state.chatType == "seller" ? "selected" : ""}`}>
                                                <div className={"tab-heading"}>
                                                    {
                                                        this.state.chatType == "seller" ? "Business" : getNameInitials(this.props.sbr.sellerName)
                                                    }
                                                </div>
                                                {
                                                    this.state.chatType == "seller" ?
                                                        <div className={"tab-contant"}>
                                                            <div className={"name"}>
                                                                {this.props.sbr.sellerName[0].toUpperCase() + this.props.sbr.sellerName.substring(1)}
                                                            </div>
                                                            <div className={"number"}>
                                                                {this.props.sbr.sellerPhone}
                                                            </div>
                                                        </div>
                                                        : ""}
                                            </div>
                                            : ""}
                                    </div>

                                    <div className={"actions-container"}>
                                        {
                                            window.innerWidth > 768 &&
                                            <div onClick={() => this.expandChat()} data-tooltip={`${this.props.isExpand ? 'Compress' : 'Expand'}`} data-position="left center" data-inverted="" className={"expend-icon-container"}>
                                                {
                                                    this.props.isExpand ?
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19.036" height="18.953" viewBox="0 0 19.036 18.953">
                                                            <g id="Group_15460" data-name="Group 15460" transform="translate(0.527 0.501)">
                                                                <g id="Group_15457" data-name="Group 15457" transform="translate(0 0.001)">
                                                                    <path id="Path_29151" data-name="Path 29151" d="M5.791,5.038c0-.1,0-.151,0-.206q-.01-1.211-.019-2.423c0-.354.14-.483.495-.5.538-.024.64.125.637.622-.008,1.186.007,2.372.012,3.559,0,.155,0,.311,0,.466a.373.373,0,0,1-.384.4q-2.128.005-4.256,0a.419.419,0,0,1-.424-.406c0-.01,0-.02,0-.03-.048-.544.19-.7.658-.692.752.017,1.5,0,2.257,0h.209c-.08-.082-.132-.138-.187-.191Q2.509,3.371.225,1.1A.584.584,0,0,1,.037.45a.556.556,0,0,1,.917-.2L4.739,4l.914.907c.035.035.072.068.138.13" transform="translate(0 -0.081)" fill="#cbcbcb" stroke="#cbcbcb" stroke-width="1" />
                                                                    <path id="Path_29152" data-name="Path 29152" d="M5.744,366.824a1.611,1.611,0,0,1-.138.18q-2.295,2.279-4.592,4.555a.558.558,0,0,1-.9-.026.554.554,0,0,1,.1-.751q1.234-1.23,2.469-2.458,1.085-1.078,2.172-2.155c.035-.035.069-.072.135-.143H4.8l-2.409,0a.466.466,0,0,1-.528-.53c0-.02,0-.04,0-.061,0-.382.151-.534.529-.534l2.166,0H6.5a.393.393,0,0,1,.429.474c-.01.1,0,.21,0,.315q-.009,1.893-.018,3.787c0,.337-.129.464-.467.467h-.2a.41.41,0,0,1-.463-.468c0-.818.013-1.636.019-2.454,0-.054,0-.108,0-.162l-.057-.038" transform="translate(-0.009 -353.826)" fill="#cbcbcb" stroke="#cbcbcb" stroke-width="1" />
                                                                    <path id="Path_29153" data-name="Path 29153" d="M366.754,4.946c.052-.06.1-.124.155-.18l4.554-4.53a.618.618,0,0,1,.547-.23.539.539,0,0,1,.453.354.519.519,0,0,1-.119.574c-.252.262-.513.515-.771.772L367.64,5.616c-.031.031-.059.065-.111.123h.189c.8,0,1.6,0,2.394,0A.457.457,0,0,1,370.6,6a.712.712,0,0,1-.051.707.438.438,0,0,1-.39.157q-1.848-.008-3.7-.009c-.162,0-.323.006-.485,0a.367.367,0,0,1-.379-.385q.01-2.111.02-4.223a.365.365,0,0,1,.194-.38.921.921,0,0,1,.706,0,.374.374,0,0,1,.206.39c-.006.828-.007,1.656-.009,2.484,0,.055,0,.11,0,.166l.042.032" transform="translate(-354.5 0)" fill="#cbcbcb" stroke="#cbcbcb" stroke-width="1" />
                                                                    <path id="Path_29154" data-name="Path 29154" d="M367.077,367.051c0,.085,0,.134,0,.183q0,1.235.007,2.469c0,.344-.132.473-.472.484-.464.016-.641-.049-.637-.624.01-1.207-.006-2.414-.012-3.62,0-.115.005-.231,0-.345a.385.385,0,0,1,.416-.455H369.1c.48,0,.96,0,1.439,0a.427.427,0,0,1,.471.453c0,.06,0,.121,0,.182a.46.46,0,0,1-.5.489q-1.212,0-2.424,0h-.2c.059.062.094.1.131.138q2.309,2.3,4.62,4.592a.575.575,0,0,1,.179.642.545.545,0,0,1-.869.235c-.189-.158-.359-.34-.534-.515l-4.211-4.188c-.032-.032-.066-.062-.128-.121" transform="translate(-354.853 -354.06)" fill="#cbcbcb" stroke="#cbcbcb" stroke-width="1" />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                        :
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="19.003" height="18.946" viewBox="0 0 19.003 18.946">
                                                            <g id="Group_15459" data-name="Group 15459" transform="translate(0.5 0.5)">
                                                                <g id="Group_15457" data-name="Group 15457" transform="translate(0 -0.001)">
                                                                    <path id="Path_29152" data-name="Path 29152" d="M5.744,366.824a1.611,1.611,0,0,1-.138.18q-2.295,2.279-4.592,4.555a.558.558,0,0,1-.9-.026.554.554,0,0,1,.1-.751q1.234-1.23,2.469-2.458,1.085-1.078,2.172-2.155c.035-.035.069-.072.135-.143H4.8l-2.409,0a.466.466,0,0,1-.528-.53c0-.02,0-.04,0-.061,0-.382.151-.534.529-.534l2.166,0H6.5a.393.393,0,0,1,.429.473c-.01.1,0,.21,0,.315q-.009,1.893-.018,3.786c0,.337-.129.464-.467.467h-.2a.41.41,0,0,1-.463-.468c0-.818.013-1.636.019-2.453,0-.054,0-.108,0-.162l-.057-.038" transform="translate(11.071 -364.898)" fill="#cbcbcb" stroke="#cbcbcb" stroke-width="1" />
                                                                    <path id="Path_29153" data-name="Path 29153" d="M366.754,4.945c.052-.06.1-.124.155-.18L371.462.236a.618.618,0,0,1,.547-.23.539.539,0,0,1,.453.354.519.519,0,0,1-.119.574c-.252.262-.513.515-.771.772L367.64,5.615c-.031.031-.059.065-.111.123h.189c.8,0,1.6,0,2.394,0a.457.457,0,0,1,.484.264.712.712,0,0,1-.051.707.438.438,0,0,1-.39.157q-1.848-.008-3.7-.009c-.162,0-.323.006-.485,0a.367.367,0,0,1-.379-.385q.01-2.111.02-4.222a.365.365,0,0,1,.194-.38.921.921,0,0,1,.706,0,.374.374,0,0,1,.206.39c-.006.828-.007,1.656-.009,2.484,0,.055,0,.11,0,.166l.042.032" transform="translate(-365.594 11.078)" fill="#cbcbcb" stroke="#cbcbcb" stroke-width="1" />
                                                                </g>
                                                            </g>
                                                        </svg>
                                                }
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className={"seperator"} style={{paddingBottom:'5px'}}></div>
                                <div id={"chat-container-id"} className={`chat-container ${this.props.isExpand ? "expand" : ""}`}>
                                    <>
                                        <MessageList
                                            className={`message-list ${this.state.chatType}`}
                                            lockable={true}
                                            toBottomHeight={'100%'}
                                            downButton={true}
                                            // onDownload={(e) => {this.downloadChatImage(e)}}
                                            // onLoad={(e) => {this.handleOnLoad(e)}}
                                            // onPhotoError={(e) => {this.handleOnPhotoError(e)}}
                                            // onOpen={(e) => {console.log( "click", e)}}
                                            onClick={(e) => {this.downloadChatImage(e)}}
                                            onRemoveMessageClick={(messageObject,messageObjectIndex,event) => {this.handleDeleteSmsClick(messageObject,event)}}
                                            // onClick={(e) => {console.log( "click", e)}} //working
                                            dataSource={
                                                [...this.state.chatData,
                                                    // , ...this.state.chatData,
                                                // {
                                                //         position: 'left',
                                                //         type: 'photo',
                                                //         text: 'react.svg',
                                                //         data: {
                                                //             width : 100,
                                                //             height: 100,
                                                //             uri: ['https://5365-103-159-75-243.ngrok.io/api/uploads/get/m-efc-4-f-69764-b-52-bd-0-cdfc_li7na4bl0b3zlra_.jpeg'],
                                                //             status: {
                                                //                 click: true,
                                                //                 loading: 1,
                                                //             }
                                                //         },          
                                                //     },
                                                //     {
                                                //     position: 'left',
                                                //     type: 'photo',
                                                //     text: 'react2.svg',
                                                //     data: {
                                                //         uri: ['https://5365-103-159-75-243.ngrok.io/api/uploads/get/me-9-fea-2461-ddeeeab-99-ce-3-_li7na4bl0b3zlsv_.jpeg'],
                                                //         status: {
                                                //             click: true,
                                                //             loading: 1,
                                                //         }
                                                //     }
                                                //     }                                              
                                            ]
                                            }
                                        />
                                    </>
                                </div>
                                <div className={"seperator"}>
                                </div>
                                <div className={`input-container ${this.props.isExpand ? "expand" : ""}`}>
                                    {
                                        <div className={`snippets-modal-container ${this.props.isSnippetsOpen ? "show" : ""}`}>
                                            {
                                                this.props.isSnippetsOpen &&
                                                    !this.state.isSnippetsLoaded ?
                                                    <Dimmer active={true}>
                                                        <Loader active={true} size='massive'> </Loader>
                                                    </Dimmer>
                                                    :
                                                    <div className={'snippets-modal-inner-container'} >
                                                        <ChatSnippets key={"chatSnippets-key-" + this.props.singleBuyerRequestID} chatCnippetsData={this.state.chatSnippetsData} onSnippetSelect={this.onSnippetSelect} />
                                                    </div>
                                            }
                                            <svg className={"bottom-notch"} xmlns="http://www.w3.org/2000/svg" width="16.376" height="10.078" viewBox="0 0 16.376 10.078">
                                                <path id="Polygon_9" data-name="Polygon 9" d="M8.188,0l8.188,10.078H0Z" transform="translate(16.376 10.078) rotate(180)" fill="#fef5e2" />
                                            </svg>
                                        </div>
                                    }
                                    <Input
                                        className={"message-input"}
                                        placeholder="Write your message here …"
                                        // ref={this.inputField}
                                        referance={this.inputField}
                                        key={"inputField-" + this.state.inputFieldKey}
                                        multiline={true}
                                        minHeight={60}
                                        //inputStyle={{ height: this.state.textAreaHeight }}
                                        defaultValue={this.state.messageText}
                                        onChange={(e) => { this.valueChange(e) }}
                                        maxlength={2048}
                                        rightButtons={
                                            this.state.enableMessaging && this.state.sendSMSEnabled &&
                                            <>
                                                <div className={"actions-container"}>
                                                    <div onClick={() => this.toggleSnippets()} className={"attahcment-icon-container"} data-tooltip={`Snippets`} data-position="top center" data-inverted="" >

                                                        <svg className={`attahcment-icon ${this.props.isSnippetsOpen ? "highlighted" : ""} `} xmlns="http://www.w3.org/2000/svg" width="25.781" height="25.774" viewBox="0 0 25.781 25.774">
                                                            <defs>
                                                                <clipPath id="clip-path">
                                                                    <rect id="Rectangle_8827" data-name="Rectangle 8827" width="25.781" height="25.774" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                </clipPath>
                                                            </defs>
                                                            <g id="Group_15949" data-name="Group 15949" clip-path="url(#clip-path)">
                                                                <path id="Path_29303" data-name="Path 29303" d="M0,12.873Q0,6.82,0,.767C0,.166.169,0,.778,0H6.4a2.034,2.034,0,0,1,.265.007.563.563,0,0,1,.01,1.116,2,2,0,0,1-.289.012c-1.664,0-3.328,0-4.992,0-.195,0-.26.046-.26.252q.008,11.5,0,23.006c0,.2.061.255.258.254,1.664-.007,3.328,0,4.992,0a2.068,2.068,0,0,1,.289.011.558.558,0,0,1,.482.595.546.546,0,0,1-.55.527q-3.027,0-6.054,0a.535.535,0,0,1-.543-.505c-.008-.1,0-.193,0-.289q0-6.053,0-12.106" transform="translate(-0.001 0)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                <path id="Path_29304" data-name="Path 29304" d="M392.62,12.905q0,6.041,0,12.082c0,.08,0,.161,0,.241a.545.545,0,0,1-.572.554q-3,0-6.006,0a.547.547,0,0,1-.573-.528.553.553,0,0,1,.527-.6c.12-.011.241-.006.361-.006,1.624,0,3.248,0,4.872,0,.194,0,.261-.045.261-.252q-.008-11.5,0-23.007c0-.2-.063-.254-.259-.253q-2.52.011-5.041,0a1.054,1.054,0,0,1-.439-.087.534.534,0,0,1-.272-.612.572.572,0,0,1,.5-.426,2.092,2.092,0,0,1,.217,0h5.692c.551,0,.734.184.734.74q0,6.077,0,12.155" transform="translate(-366.839 -0.01)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                <path id="Path_29305" data-name="Path 29305" d="M80.521,362.709h-8.8a.574.574,0,1,1-.111-1.142,1.661,1.661,0,0,1,.217,0q8.708,0,17.415,0a1.206,1.206,0,0,1,.4.057.56.56,0,0,1,.336.606.584.584,0,0,1-.5.479c-.072.007-.145,0-.217,0H80.521" transform="translate(-67.635 -344.092)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                <path id="Path_29306" data-name="Path 29306" d="M80.547,149.3q-4.352,0-8.7,0a1.06,1.06,0,0,1-.478-.117.485.485,0,0,1-.242-.535.52.52,0,0,1,.384-.45,1.267,1.267,0,0,1,.333-.039q8.728,0,17.455,0a1.01,1.01,0,0,1,.518.14.482.482,0,0,1,.192.555.575.575,0,0,1-.491.438,1.5,1.5,0,0,1-.265.008h-8.7" transform="translate(-67.679 -140.991)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                                <path id="Path_29307" data-name="Path 29307" d="M78.83,254.732H85.8a2.156,2.156,0,0,1,.241,0,.573.573,0,0,1,.529.584.589.589,0,0,1-.528.565,1.874,1.874,0,0,1-.217,0H71.861c-.072,0-.145,0-.217,0a.594.594,0,0,1-.543-.576.579.579,0,0,1,.541-.574,2.38,2.38,0,0,1,.241,0H78.83" transform="translate(-67.666 -242.424)" fill="#ff5457" stroke="#ff5457" stroke-width="1" />
                                                            </g>
                                                        </svg>
                                                        {/* <svg className={`attahcment-icon `} xmlns="http://www.w3.org/2000/svg" width="18.805" height="21.363" viewBox="0 0 18.805 21.363">
                                                            <path id="Shape" d="M2.035,9.254,9.782,1.507a5.145,5.145,0,0,1,7.276,7.276L9.311,16.53A3.166,3.166,0,0,1,4.885,12l7.7-7.7A1.187,1.187,0,0,1,14.26,5.984l-7.7,7.7A.792.792,0,1,0,7.683,14.8l7.7-7.7a2.77,2.77,0,0,0-3.918-3.918l-7.7,7.7A4.749,4.749,0,0,0,10.482,17.6l6.3-6.3a1.187,1.187,0,1,1,1.679,1.679l-6.3,6.3A7.124,7.124,0,0,1,2.035,9.254Z" fill="#b5b5be" />
                                                        </svg> */}
                                                    </div>
                                                    <div className={`send-icon-container`} data-tooltip={`Send message`} data-position="top center" data-inverted="" onClick={(e) => { this.state.disableSendBtn || !this.state.enableMessaging ? null : this.sendMessage(e) }} >
                                                        <svg className={`send-icon ${this.state.disableSendBtn || this.state.messageText.length == 0 ? "disabled" : ""}`} xmlns="http://www.w3.org/2000/svg" width="31.001" height="31.001" viewBox="0 0 31.001 31.001">
                                                            <path id="direct" d="M21.885.927l-6.7,20.507a.708.708,0,0,1-1.283.136L9.4,13.82a.707.707,0,0,1,.043-.777l1.618-2.178L8.878,12.483a.707.707,0,0,1-.777.043L.351,8.02A.708.708,0,0,1,.487,6.736L20.994.035a.708.708,0,0,1,.892.892Z" transform="translate(15.5) rotate(45)" fill="#377dff" />
                                                        </svg>
                                                    </div>
                                                </div>
                                            </>
                                        } />
                                </div>
                                {
                                    this.state.showError ? <div id={"error-box-container-id"} className={"error-container-box"}>
                                        <ErrorBox message={this.state.errorMessage} />
                                    </div> : null
                                }
                            </>
                    }

                    {
                        this.state.selectedChatImagesURI.length > 0 &&
                        <Lightbox image={this.state.selectedChatImagesURI}
                            // images={this.state.lbImages}
                            onClose={() => this.setState({ selectedChatImagesURI: "" })}
                            // startIndex={this.state.selectedLBImage}
                            >
                        </Lightbox>
                    }
                    {
                        <Modal size={"mini"} className={"save-image-confim-modal"}
                            open={this.state.saveAsImageModalOpen}
                            onClose={() => this.setState({ isRefundModalOpen: false })}
                        >
                            <Modal.Header>Attach Image</Modal.Header>
                            <Modal.Content>
                                <p style={{ fontSize: "14px" }}>
                                    {
                                        "Do you want to attach this image to this request ?"
                                    }
                                </p>
                                {this.state.imageSaveAsError ?
                                    <Message negative>
                                        <p>{this.state.imageSaveAsError}</p>
                                    </Message>
                                    : ''}
                            </Modal.Content>
                            <Modal.Actions>
                                <Button 
                                    disabled={this.state.saveAsImageModalSaveButtonDisabled}
                                    onClick={() => this.setState({ saveAsImageModalOpen: false  , imageSaveAsError: ""})}>
                                    Close
                                </Button>
                                <Button
                                    loading={this.state.saveAsImageModalSaveButtonDisabled}
                                    disabled={this.state.saveAsImageModalSaveButtonDisabled}
                                    content='Save'
                                    positive
                                    onClick={(e) => { this.saveImageAsSBRPhoto(e, this.state.selectedMediaObject) }}
                                // disabled={!this.state.refundAmount}
                                />
                            </Modal.Actions>
                        </Modal>
                    }
                    {
                        <Confirm
                            className="confirm"
                            confirmButton='Delete'
                            size="large"
                            open={this.state.openSmsDeleteConfirmModal}
                            closeOnDimmerClick
                            closeOnEscape
                            content="Do you want to delete a messsage?"
                            onConfirm={() => this.onSmsDeleteConfirm()}
                            onCancel={() => this.onSmsDeleteConfirmModalClose()}
                            onClose={() => this.onSmsDeleteConfirmModalClose()}
                        />
                    }

                </div>
            </>
        )
    }
}

function mapStateToProps({ auth }) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        currentUser: auth.currentUser,
    }
}

export default connect(mapStateToProps)(ChatContainerNew);

